import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, FormControlLabel } from "@mui/material";
import { handleConfirmClick } from "./NavigationButtons-utils";
export const ConfirmChangesCheckbox = ({ isConfirmChangesChecked, setIsConfirmChangesChecked, label, loading, }) => {
    return (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: isConfirmChangesChecked, onChange: handleConfirmClick(setIsConfirmChangesChecked) }), label: label, labelPlacement: "end", disabled: loading, sx: {
            mx: {
                xx: 0,
                md: 2,
            },
        }, slotProps: {
            typography: {
                sx: (theme) => ({
                    color: isConfirmChangesChecked ? theme.palette.success.main : theme.palette.error.main,
                    fontWeight: "bold",
                    fontStyle: "italic",
                    textAlign: "start",
                }),
            },
        } }));
};
